import {Grid, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {VehicleWarehouseMotLayout} from '../../../utils/getVehicleWarehouseMotLayout';
import {VehicleWarehouseAdaptiveMotProps} from '../types/VehicleWarehouseAdaptiveMotProps';

export function renderVehicleWarehouseMotContent(
  props: VehicleWarehouseAdaptiveMotProps,
  layout: VehicleWarehouseMotLayout
) {
  return match({mode: layout.mode, size: props.size})
    .with({mode: 'aggregate'}, () => props.renderAggregate(false))
    .with({mode: 'detail', size: 'wide'}, () => (
      <Grid columns={2} spacing={4}>
        {props.renderSection('expired', props.expiredCount, props.expiredRows, layout.rows.expired)}
        {props.renderSection(
          'expiring',
          props.expiringCount,
          props.expiringRows,
          layout.rows.expiring
        )}
      </Grid>
    ))
    .with({mode: 'detail'}, () => (
      <VStack spacing={4}>
        {props.renderSection('expired', props.expiredCount, props.expiredRows, layout.rows.expired)}
        {props.renderSection(
          'expiring',
          props.expiringCount,
          props.expiringRows,
          layout.rows.expiring
        )}
      </VStack>
    ))
    .exhaustive();
}
